module.exports = __webpack_public_path__ + "static/media/successCheckbox.2a35b528.svg";